import { yup } from '@guiker/shared-framework'

export * from './managers/schema'

export const updatePropRentalPayoutMethod = yup.object({
  payoutMethodId: yup.string().required(),
})
